import React from 'react'
import { listAnalysesByLinkedOpportunityId, type AnalysisItem } from '../services/analysisService'

type UseLinkedOpportunityAnalysesResult = {
  items: AnalysisItem[]
  loading: boolean
  error: string | null
}

export function useLinkedOpportunityAnalyses(
  opportunityId: number | null,
  enabled: boolean,
): UseLinkedOpportunityAnalysesResult {
  const [items, setItems] = React.useState<AnalysisItem[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!enabled || opportunityId == null) {
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listAnalysesByLinkedOpportunityId({ opportunityId })
      .then((next) => {
        if (!active) return
        setItems(next || [])
      })
      .catch((e: any) => {
        if (!active) return
        setItems([])
        setError(e?.message || 'Falha ao carregar historico de analises')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, opportunityId])

  return { items, loading, error }
}
